import { isProductionServer } from '@/constants/constant';

import { getUserInfo } from '@/utils/Util';

let testToken = 'tt-pNLS6eFKBYW';
let productionToken = 'tt-Y56vWibBXo7';
let testSurveyName = 'Test-general-Feedback-admin';
let productionSurveyName = 'Production-general-Feedback-admin';

export const loadGlobalSurveyWidget = () => {
	if (document.getElementById('ss-widget')) return;
	const script = document.createElement('script');
	script.id = 'ss-widget';
	script.async = true;
	script.src = `https://nitex.surveysparrow.com/widget/${isProductionServer() ? productionToken : testToken}`;

	const customParams = {
		name: getUserInfo()?.name,
		user_email: getUserInfo()?.email,
		designation: getUserInfo()?.designation?.replace(/&/g, 'and'),
		organization_type: getUserInfo()?.organizationType,
		user_type: getUserInfo()?.primaryUserType,
		nitex_role: getUserInfo()?.userLevelName,
		user_id: getUserInfo()?.id
	};

	window.SS_WIDGET_TOKEN = isProductionServer() ? productionToken : testToken;
	window.SS_ACCOUNT = 'nitex.surveysparrow.com';
	window.SS_SURVEY_NAME = isProductionServer() ? productionSurveyName : testSurveyName;
	window.SS_VARIABLES = customParams;

	script.onload = () => {
		if (window.SurveySparrow) {
			window.SurveySparrow.init({
				token: isProductionServer() ? productionToken : testToken,
				variables: customParams
			});
		}
	};
	document.body.appendChild(script);
};

export const cleanupGlobalSurveyWidget = () => {
	const widget = document.getElementById('ss-widget');
	if (widget) {
		widget.remove();
	}
};
